export const ScreenView = {
  EMAIL: "EMAIL",
  PHONE_NUMBER: "PHONE_NUMBER",
  PASSWORD: "PASSWORD",
  OTP: "OTP",
  FORGOT_PASSWORD: "FORGOT_PASSWORD",
  RESET_PASSWORD: "RESET_PASSWORD",
  FORGOT_SUCCESS: "FORGOT_SUCCESS",
};

export const ScreenViewHeading: any = {
  EMAIL: "Sign In",
  PHONE_NUMBER: "Sign In",
  PASSWORD: "Sign In",
  OTP: "Sign In",
  FORGOT_PASSWORD: "Forgot Password",
  RESET_PASSWORD: "Set New Password",
  FORGOT_SUCCESS: "Check Your Email",
};

export const ScreenViewSubHeading: any = {
  EMAIL_ONLY: "Please enter your email address to access your account.",
  PHONE_NUMBER_ONLY: "Please enter your phone number to access your account.",
  EMAIL:
    "Please enter your email address or phone number to access your account.",
  PHONE_NUMBER:
    "Please enter your email address or phone number to access your account.",
  PASSWORD: null,
  OTP: null,
  FORGOT_PASSWORD: "No worries, we will send you reset instructions.",
  RESET_PASSWORD: "A strong password is essential for your account security.",
  FORGOT_SUCCESS:
    "You will receive a password reset link if the email address you entered is registered with us.",
};

export const ScreenViewButtonLabel: any = {
  EMAIL: "Continue",
  PHONE_NUMBER: "Get OTP",
  PASSWORD: "Sign In",
  OTP: "Verify OTP",
  FORGOT_PASSWORD: "Set New Password",
  RESET_PASSWORD: "Set New Password",
  FORGOT_SUCCESS: "Go back to Sign In",
};
